/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Form } from 'semantic-ui-react';
import { string, shape, arrayOf } from 'prop-types';
import { FastField, Field } from 'formik';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { DropdownField, MaskedInputField } from 'Modules/Formik';

import style from './PhoneInput.less';

const phoneMask = createNumberMask({
  prefix: '',
  allowDecimal: false,
  includeThousandsSeparator: false,
  integerLimit: 10,
  allowLeadingZeroes: true,
});

const PhoneNumber = props => {
  const { label, options } = props;

  return (
    <Form.Field style={{ marginBottom: 0 }}>
      <label>{label}</label>
      <div className={style.content}>
        <Field
          name="phoneCountryCode"
          component={DropdownField}
          placeholder="Country Code"
          options={options}
        />
        <FastField
          name="phoneNumber"
          component={MaskedInputField}
          mask={phoneMask}
          guide
          showMask
          placeholder="Phone Number"
          excludeSeparator
        />
      </div>
    </Form.Field>
  );
};

PhoneNumber.propTypes = {
  label: string,
  options: arrayOf(shape({})),
};

PhoneNumber.defaultProps = {
  label: 'Phone Number',
  options: [],
};

export default PhoneNumber;
